// src/pages/Userpanel/Packages.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Packages = () => {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // 🔥 New states
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [balance, setBalance] = useState(0);
  const [isBuying, setIsBuying] = useState(false);
  const [purchasedPackages, setPurchasedPackages] = useState([]);

  const token = localStorage.getItem("token");

  // Fetch packages + user data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 🔹 Packages
        const packagesRes = await axios.get("https://api.earnmoney0.top/admin/packages", {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (packagesRes.data.success) {
          setPackages(packagesRes.data.packages);
        } else {
          setError("No packages found");
        }

        // 🔹 User balance + purchased packages
        const userRes = await axios.get("https://api.earnmoney0.top/api/user/me", {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        setBalance(userRes.data.mainBalance || 0);
        setPurchasedPackages(userRes.data.purchasedPackages || []);

      } catch (err) {
        console.error("Fetch Error:", err);
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  const handleBuyClick = (pkg) => {
    setSelectedPackage(pkg);
    setShowPopup(true);
  };

  const handleConfirmBuy = async () => {
    if (!selectedPackage) return;
    if (isBuying) return;
    if (balance < selectedPackage.price) return;

    setIsBuying(true);

    try {
      const res = await axios.post(
        "https://api.earnmoney0.top/api/user/buy-package",
        { packageId: selectedPackage._id },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      if (res.data.success) {
        setBalance(res.data.balance);
        setPurchasedPackages(res.data.purchasedPackages);
        alert("✅ Package Purchased Successfully!");
        setShowPopup(false);
      } else {
        alert(res.data.message || "Purchase failed");
      }
    } catch (err) {
      console.error("Purchase Error:", err);
      alert("❌ Purchase failed");
    } finally {
      setIsBuying(false);
    }
  };

  if (loading) return <div style={{ padding: 20 }}>Loading Packages...</div>;
  if (error) return <div style={{ padding: 20, color: "#f87171" }}>{error}</div>;

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <span style={styles.back} onClick={() => navigate(-1)}>←</span>
        <h3>Packages</h3>
      </div>

      {/* PACKAGES */}
      <div style={styles.grid}>
        {packages.map((p) => (
          <div key={p._id} style={styles.card}>
            <h3>{p.name}</h3>
            <h2>৳ {p.price}</h2>

            <ul style={styles.list}>
              <li>✔ Daily Ads: {p.dailyAds}</li>
              <li>✔ Validity: {p.validity} days</li>
              <li>✔ Refer Level: {p.referLevel}</li>
            </ul>

           {(typeof purchasedPackages === "string" ? purchasedPackages.split(" + ") : purchasedPackages).includes(p.name) ? (
  <button
    style={{
      ...styles.btn,
      background: "#9ca3af",
      cursor: "not-allowed",
    }}
    disabled
  >
    Already Purchased<br />Try Another Plan
  </button>
) : (
  <button style={styles.btn} onClick={() => handleBuyClick(p)}>
    BUY NOW
  </button>
)}
          </div>
        ))}
      </div>

      {/* 🔥 BUY POPUP */}
      {showPopup && selectedPackage && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <h3 style={{ textAlign: "center", color: "#7a0f7a", marginBottom: 10 }}>
              {selectedPackage.name} BUY
            </h3>

            <div style={{ background: "#f9fafb", padding: 12, borderRadius: 10 }}>
              <p style={{ color: "#16a34a", fontWeight: 600 }}>
                💰 Price: ৳ {selectedPackage.price}
              </p>
              <p style={{ color: "#0ea5e9" }}>
                📊 Daily Ads: {selectedPackage.dailyAds}
              </p>
              <p style={{ color: "#9333ea" }}>
                ⏳ Validity: {selectedPackage.validity} Days
              </p>
              <p style={{ color: "#f97316", fontWeight: 600 }}>
                📈 Income: ৳ {selectedPackage.dailyAds * selectedPackage.validity * 10}
              </p>
            </div>

            <div
              style={{
                marginTop: 12,
                background: "#ede9fe",
                padding: 10,
                borderRadius: 8,
                textAlign: "center",
                fontWeight: 700,
              }}
            >
              Main Balance: ৳ {balance}
            </div>

            <div style={styles.popupActions}>
              <button
                style={{ ...styles.cancelBtn }}
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>

              {balance >= selectedPackage.price ? (
                <button
                  style={{
                    ...styles.confirmBtn,
                    opacity: isBuying ? 0.6 : 1,
                    cursor: isBuying ? "not-allowed" : "pointer",
                  }}
                  onClick={handleConfirmBuy}
                  disabled={isBuying}
                >
                  {isBuying ? "Processing..." : "Confirm"}
                </button>
              ) : (
                <button style={styles.disabledBtn} disabled>
                  Balance Low
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Packages;

/* ---------------- STYLES ---------------- */

const styles = {
  page: { background: "#f2f2f2", minHeight: "100vh" },
  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: 15,
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  back: { fontSize: 22, cursor: "pointer" },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: 15,
    padding: 15,
  },
  card: {
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  list: { listStyle: "none", padding: 0, fontSize: 14 },
  btn: {
    width: "100%",
    marginTop: 10,
    padding: 10,
    background: "#7a0f7a",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },

  /* Popup */
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },
  popup: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    width: "90%",
    maxWidth: 400,
  },
  popupActions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 15,
  },
  cancelBtn: {
    background: "#e5e7eb",
    padding: "8px 14px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
  },
  confirmBtn: {
    background: "#22c55e",
    padding: "8px 14px",
    borderRadius: 8,
    border: "none",
    fontWeight: 700,
    cursor: "pointer",
  },
  disabledBtn: {
    background: "#9ca3af",
    padding: "8px 14px",
    borderRadius: 8,
    border: "none",
    cursor: "not-allowed",
  },
};